import { j as e } from "./jsx-runtime-C5mzlN2N.js";
import { s as P } from "./index-LNp6rxyU.js";
import { H as y } from "./RouteGuard-BZ_VsiXc.js";
import { useEffect as N } from "react";
import { C as E } from "./CategoryHeading-D06WK_Wo.js";
import { H as m, P as H } from "./Markdown-DqDbGCj2.js";
import { P as T } from "./Pagination-9TA5cwCh.js";
import { T as k } from "./Toc-BVdRaIC0.js";
import { a as C, b as R } from "./hook-pPrHCB6G.js";
import { c as _ } from "./cn-qaFjX9_3.js";
import { u as I } from "./index-BPmAnNGI.js";
const M = {
  h2: ({ children: i, id: s }) => /* @__PURE__ */ e.jsx(m, { level: 2, id: s, registerSidebarAnchor: !0, children: i }),
  h3: ({ children: i, id: s }) => /* @__PURE__ */ e.jsx(m, { level: 3, id: s, registerSidebarAnchor: !0, children: i })
}, G = ({
  mdxComponent: i,
  file: s,
  frontmatter: a = {},
  defaultOptions: o,
  tableOfContents: n,
  excerpt: x
}) => {
  var h, p, f;
  const j = (h = C()) == null ? void 0 : h.categoryLabel, t = a.title, c = a.category ?? j, v = a.toc === !1 || (o == null ? void 0 : o.toc) === !1, b = ((p = n.find((r) => r.depth === 1)) == null ? void 0 : p.value) ?? t, w = a.disablePager ?? (o == null ? void 0 : o.disablePager) ?? !1, g = ((f = n.find((r) => r.depth === 1)) == null ? void 0 : f.children) ?? // if `title` is provided by frontmatter it does not appear in the table of contents
  n.filter((r) => r.depth === 2), u = !v && g.length > 0, { prev: l, next: d } = R();
  return N(() => {
    if (process.env.NODE_ENV === "development")
      return window.__getReactRefreshIgnoredExports = ({ id: r }) => {
        if (r.endsWith(s))
          return ["frontmatter", "tableOfContents"];
      }, () => {
        window.__getReactRefreshIgnoredExports = void 0;
      };
  }, [s]), /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "grid grid-cols-1 xl:grid-cols-[--sidecar-grid-cols] gap-8 justify-between",
      "data-pagefind-filter": "section:markdown",
      "data-pagefind-meta": "section:markdown",
      children: [
        /* @__PURE__ */ e.jsxs(y, { children: [
          /* @__PURE__ */ e.jsx("title", { children: b }),
          x && /* @__PURE__ */ e.jsx("meta", { name: "description", content: x })
        ] }),
        /* @__PURE__ */ e.jsxs(
          "div",
          {
            className: _(
              H,
              "max-w-full xl:w-full xl:max-w-3xl flex-1 flex-shrink pt-[--padding-content-top]"
            ),
            children: [
              (c || t) && /* @__PURE__ */ e.jsxs("header", { children: [
                c && /* @__PURE__ */ e.jsx(E, { children: c }),
                t && /* @__PURE__ */ e.jsx(m, { level: 1, id: P(t), children: t })
              ] }),
              /* @__PURE__ */ e.jsx(
                i,
                {
                  components: { ...I(), ...M }
                }
              ),
              !w && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                /* @__PURE__ */ e.jsx("hr", { className: "my-10" }),
                /* @__PURE__ */ e.jsx(
                  T,
                  {
                    prev: l ? { to: l.id, label: l.label } : void 0,
                    next: d ? { to: d.id, label: d.label } : void 0,
                    className: "mb-4"
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ e.jsx("div", { className: "hidden xl:block", children: u && /* @__PURE__ */ e.jsx(k, { entries: g }) })
      ]
    }
  );
};
export {
  G as MdxPage
};
//# sourceMappingURL=MdxPage-B7MyVLV5.js.map
